<!-- header -->
<div class="auth-fluid" >
    <!--Auth fluid left content -->
    <div class="auth-fluid-form-box">
        <div class="align-items-center d-flex h-100">
            <div class="card-body">
                <!-- Logo -->
                <div class="auth-brand text-center text-lg-left">
                    <a  class="logo-dark">
                        <span><img src="assets/images/logo-AA.png" alt="" height="24"></span>
                    </a>
                </div>
                <!-- email send icon with text-->
                <div class="text-center m-auto">
                    <img src="assets/images/mail_sent.svg" alt="mail sent image" height="64" />
                    <h4 class="text-dark-50 text-center mt-4 font-weight-bold">Please Check Your Email</h4>
                    <p class="text-muted mb-4"> 
                        An email has been sent to <b>{{email}}</b>. Please check your email and click on the 
                        included link to activate your account.
                    </p>
                </div>
                <!-- form -->
                    <div class="form-group mb-0 text-center">
                        <button class="btn btn-primary btn-block" 
                        type="submit" [routerLink]="['/login']"  ><span class="mdi mdi-home mr-1"></span> Back to Home </button>
                    </div>
            </div> <!-- end .card-body -->
        </div> <!-- end .align-items-center.d-flex.h-100-->
    </div>
    <!-- end auth-fluid-form-box-->
    <!-- Auth fluid right content -->
    <div class="auth-fluid-right text-center">
        <div class="auth-user-testimonial">
            <h1 class="mb-3">Welcome </h1>
            <p class="lead ">Build Your Dealership On A Solid Foundation with RockIT DMS.</p>
            <footer class="footer-alt p-1 d-flex align-items-end justify-content-between">
                <p class="text-muted mb-0">2020 Rock IT DMS</p>
                <div class="d-flex">
                    <a class="text-muted mx-2 mb-0" [routerLink]="['/privacy']"  >Privacy </a>
                    <p class="text-muted mx-2 mb-0" >Legal</p>
                    <a class="text-muted mx-2 mb-0" [routerLink]="['/contact']">Contact</a>
                </div>
            </footer>
        </div> <!-- end auth-user-testimonial-->
    </div>
    <!-- end Auth fluid right content -->
</div>

